import { useEffect } from 'react';

const useAutoReload = () => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (document.readyState === 'complete' && document.body.innerHTML.trim() === '') {
        console.warn("Blank page detected. Reloading...");
        window.location.reload(); // Hard reload if blank screen is detected
      }
    }, 5000); // Check after 5 seconds

    return () => clearTimeout(timeout);
  }, []);
};

export default useAutoReload;
